export const formatNumber = (str: number) => {
  const formatted = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(str);

  return formatted.replace(/\s/g, '\u202F').replace('-', '\u2212');
};
